import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative py-16 md:py-20"
      style={{ backgroundColor: "#F7F5F0", borderTop: "1px solid rgba(28,30,33,0.08)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <p
            className="serif text-2xl tracking-[0.3em] text-[#15243D] mb-4"
            style={{ fontWeight: 400 }}
          >
            ANCHOR
          </p>
          <p className="text-sm font-light text-[#5A5D63] max-w-sm leading-relaxed">
            A quiet practice for moving through life with awareness, presence,
            and intentional action.
          </p>
          <p className="mt-5 text-[10px] tracking-[0.25em] uppercase text-[#C07865]">
            ICF Certified Coach
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <p className="text-xs tracking-[0.2em] uppercase text-[#8A8D93] mb-4">
            Practice
          </p>
          <ul className="space-y-2 text-sm font-light text-[#15243D]">
            <li>
              <Link to="/program" className="hover:text-[#C07865] transition-colors" data-testid="footer-program-link">
                28-Day Program
              </Link>
            </li>
            <li>
              <Link to="/apply" className="hover:text-[#C07865] transition-colors" data-testid="footer-apply-link">
                Apply for Coaching
              </Link>
            </li>
            <li>
              <Link to="/agreement" className="hover:text-[#C07865] transition-colors" data-testid="footer-agreement-link">
                Coaching Agreement
              </Link>
            </li>
            <li>
              <Link to="/story" className="hover:text-[#C07865] transition-colors" data-testid="footer-story-link">
                Full Story
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.2em] uppercase text-[#8A8D93] mb-4">
            Connect
          </p>
          <ul className="space-y-2 text-sm font-light text-[#15243D]">
            <li>
              <a href="/#contact" className="hover:text-[#C07865] transition-colors" data-testid="footer-contact-link">
                Contact
              </a>
            </li>
            <li>
              <a href="/#faq" className="hover:text-[#C07865] transition-colors" data-testid="footer-faq-link">
                FAQ
              </a>
            </li>
            <li>
              <Link to="/privacy" className="hover:text-[#C07865] transition-colors" data-testid="footer-privacy-link">
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="hover:text-[#C07865] transition-colors" data-testid="footer-terms-link">
                Terms
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16 pt-8 border-t border-[#15243D]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <p className="text-xs font-light text-[#8A8D93]">
          © {new Date().getFullYear()} Anchor. All rights reserved.
        </p>
        <p className="text-xs tracking-[0.2em] uppercase text-[#8A8D93]">
          Made with care.
        </p>
      </div>
    </footer>
  );
}
